import React, { Component } from 'react';
import PropTypes from 'prop-types'
import * as types from '../../../constants/actionTypes';
import Drawer from '../../Common/Drawer/Drawer';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import Notification from '../../../components/Common/Notification';
import AllLocationsForm from './AllLocationsForms';
import LocationAttributesForm from './LocationAttributesForm';
import LocationNameForm from './LocationNameForm';
import './BulkPushdownDrawer.scss';
import { Menu } from 'primereact/menu';
import MultiSelectBox from './../../Common/MultiSelectBox/MultiSelectBox';

const FORMS = {
    AllLocations: {
        Id: 'AllLocations',
        Name: 'All Locations',
        Message: 'Push task(s) to all locations which have this baseline.'
    },
    LocationName: {
        Id: 'LocationName',
        Name: 'Customize by Location Name',
        Message: 'Push task(s) to all locations listed below'
    },
    LocationAttributes: {
        Id: 'LocationAttributes',
        Name: 'Customize by Location Attributes',
        Message: 'Push task(s) to all locations listed below'
    }
}

export default class BulkPushdownDrawer extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            allLocations: [],
            selectedLocations: [],
            isFormValid: true,
            isLoading: false,
            currentForm: FORMS.AllLocations.Id,
            isProjectsActive: false,
            isProjectIdRequiredForLocationTask: false,
            projectId: '',
            projects: []
        };
    }

    async componentDidMount() {
        await this.loadBulkPushdownFilters();
    }

    loadBulkPushdownFilters = async () => {
        try {
            this.setState({ isLoading: true });
            const response = await this.props.baselineTaskActions.loadBulkPushdownFilters(this.props.baselineId);
            if (response.type === types.LOAD_BULK_PUSHDOWN_FILTERS_SUCCESS) {
                this.setState({
                    isProjectsActive: response.payload.isProjectsActive,
                    isProjectIdRequiredForLocationTask: response.payload.isProjectIdRequiredForLocationTask,
                    projects: response.payload.projects
                });
            } else if (response.type === types.LOAD_BULK_PUSHDOWN_FILTERS_FAILURE) {
                Notification("error", "An Error Occurred", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    validForm = () => {
        if (this.state.isProjectsActive === true && this.state.isProjectIdRequiredForLocationTask === true && !this.state.projectId) {
            this.setState({ isFormValid: false});
            return false;
        }

        return true;
    }

    onPushdown = async () => {
        if (!this.validForm()) {
            return;
        }

        try {
            this.setState({ isLoading: true });
            var request = {
                baselineTaskIds: this.props.checkedTasks.map(x => x.id),
                locationIds: this.state.selectedLocations.map(x => x.id),
                projectId: this.state.projectId
            }
            const response = await this.props.baselineTaskActions.bulkPushdown(request);
            if (response.type === types.PERFORM_BULK_PUSHDOWN_SUCCESS) {
                Notification("success", "Success", "Bulk Pushdown completed successfully");
                this.props.onComplete();
            } else if (response.type === types.PERFORM_BULK_PUSHDOWN_FAILURE) {
                Notification("error", "An Error Occurred", response.payload.message);
                this.setState({ isLoading: false });
            }
        } catch (error) {
            Notification("error", "Error", error);
            this.setState({ isLoading: false });
        }
    }

    setSelectedLocations = (newLocations) => {
        this.setState({ selectedLocations: newLocations });
    }

    renderForm() {

        const baselineTaskIds = this.props.checkedTasks.map(x => x.id);

        switch (this.state.currentForm) {
            case FORMS.AllLocations.Id: {
                return <AllLocationsForm
                    setSelectedLocations={this.setSelectedLocations}
                    baselineId={this.props.baselineId}
                    projectId={this.state.projectId}
                    baselineTaskIds={baselineTaskIds}
                    isProjectsActive={this.state.isProjectsActive}
                    isProjectIdRequiredForLocationTask={this.state.isProjectIdRequiredForLocationTask}
                />;
            }
            case FORMS.LocationName.Id: {
                return <LocationNameForm
                    setSelectedLocations={this.setSelectedLocations}
                    projectId={this.state.projectId}
                    selectedLocations={this.state.selectedLocations}
                    baselineId={this.props.baselineId}
                    isFormValid={this.state.isFormValid}
                    baselineTaskIds={baselineTaskIds}
                    isProjectsActive={this.state.isProjectsActive}
                    isProjectIdRequiredForLocationTask={this.state.isProjectIdRequiredForLocationTask}
                />;
            }
            case FORMS.LocationAttributes.Id: {
                return <LocationAttributesForm
                    setSelectedLocations={this.setSelectedLocations}
                    selectedLocations={this.state.selectedLocations}
                    baselineId={this.props.baselineId}
                    isFormValid={this.state.isFormValid}
                    projectId={this.state.projectId}
                    baselineTaskIds={baselineTaskIds}
                    isProjectsActive={this.state.isProjectsActive}
                    isProjectIdRequiredForLocationTask={this.state.isProjectIdRequiredForLocationTask}
                />;
            }
            default: {
                Notification("error", "Error", "Unknown Form Selected");
                return null;
            }
        }
    }

    menuOptionClick = (e) => {
        if (e.item.value === FORMS.AllLocations.Id) {
            this.setState({ currentForm: e.item.value, selectedLocations: this.state.allLocations });
        } else {
            this.setState({ currentForm: e.item.value, selectedLocations: [] });
        }
        
    }

    onCustomizeClick = (e) => {
        this.menu.toggle(e);
    }

    onProjectChange = async (value, name) => {
        this.setState({
            ...this.state,
            [name]: value.toString()
        });
    }


    render() {
        const customFooter = <div className="button-wrap text-end">
            <span>Push task(s) to {this.state.selectedLocations.length} locations</span>
            <button type="button" className="btn btn-primary button--save" onClick={this.onPushdown}>Pushdown</button>
            <button type="button" className="btn btn-secondary" onClick={this.props.onCancel}>Cancel</button>
        </div>

        const menuOptions = [
            { label: FORMS.AllLocations.Name, value: FORMS.AllLocations.Id, command: this.menuOptionClick },
            { label: FORMS.LocationName.Name, value: FORMS.LocationName.Id, command: this.menuOptionClick },
            { label: FORMS.LocationAttributes.Name, value: FORMS.LocationAttributes.Id, command: this.menuOptionClick }
        ];

        /**
         * Do not include the current form menu item in the context menu that shows 
         * when clicking the customize link
         */
        let customizeMenuOptions = menuOptions.filter(x => x.value !== this.state.currentForm);

        return (
            <div className="bulk-pushdown-drawer">
                <Menu model={customizeMenuOptions} popup={true} ref={el => this.menu = el} />
                <Drawer isWide={true}
                    title='Bulk Pushdown'
                    onCancelClick={this.props.onCancel}
                    customFooter={customFooter}>

                    <LoadingIndicator isLoading={this.state.isLoading} hideWhileLoading={true}>
                        <form noValidate className={this.state.isFormValid ? "" : "was-validated"}>

                            {this.state.isProjectsActive === true &&
                                <div className="row">
                                    <div className="col">
                                        <MultiSelectBox name="projectId"
                                            label={(this.state.isProjectIdRequiredForLocationTask === true) ? "Assign Tasks to Project" : "Assign Tasks to Project (optional)"} idField="id" valueField="name"
                                            options={this.state.projects}
                                            selectedValues={this.state.projectId.toString()}
                                            onChange={this.onProjectChange}
                                            isRequired={this.state.isProjectIdRequiredForLocationTask === true}
                                            errorMessage="Project is required"
                                            isMulti={false} />
                                    </div>
                                </div>
                            }

                            <div className="row">
                                <div className="col drawer-message">
                                    {FORMS[this.state.currentForm].Message}
                                    <button type="button" className="btn btn-link" onClick={this.onCustomizeClick}>Customize</button>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col">
                                    {this.renderForm()}
                                </div>
                            </div>

                        </form>
                    </LoadingIndicator>

                </Drawer>
            </div>
        )
    }
}

BulkPushdownDrawer.propTypes = {
    baselineId: PropTypes.string.isRequired,
    checkedTasks: PropTypes.array.isRequired,
    onComplete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    baselineTaskActions: PropTypes.object.isRequired
};
